import { render, staticRenderFns } from "./AlponNoticeBar.vue?vue&type=template&id=342cc510&scoped=true&"
import script from "./AlponNoticeBar.vue?vue&type=script&lang=js&"
export * from "./AlponNoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./AlponNoticeBar.vue?vue&type=style&index=0&id=342cc510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cc510",
  null
  
)

export default component.exports